// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"W_-z","categoryName":"X_-z","categoryImage":"Y_-z","categoryContent":"Z_-z","bottomAligned":"__-z"};